import { local } from "d3";
import { EncryptStorage } from "encrypt-storage";
import jwtDecode from "jwt-decode";
import * as Constants from "common/constants";
import * as General from "common/general";

const encryptStorage1 = new EncryptStorage("secret-key-value", {
	prefix: "@mwan",
});
export const validToken = (accessToken) => {
	const decodedToken = jwtDecode(accessToken);
	const currentTime = Date.now() / 1000;
	if (decodedToken.exp > currentTime) {
		return true;
	} else {
		return false;
	}
};

export const getSystemPropertyValue = async (key) => {
	let record = null;
	await GetSystemProperties();
	let systemProperties = encryptStorage1.getItem("systemProperties");

	if (systemProperties) {
		record = systemProperties.find((r) => r.propertyName === key);
	}

	return record ? record.propertyValue : null;
};

const GetSystemProperties = () => {
	const GetSystemPropertiesSuccess = (responseObject) => {
		var isSuccess = false;
		if (responseObject.status == Constants.SuccessStatus) {
			if (responseObject.data != null) {
				if (responseObject.data.token != null) {
					if (responseObject.data.token.accessToken != "") {
						let responseData = responseObject.data.dataBaseContent;
						setConfig("systemProperties", responseData);
						encryptStorage1.setItem("systemProperties", responseData);
						isSuccess = true;
					}
				}
			}
		}
	};

	const GetSystemPropertiesFailure = (GetSystemPropertiesFailure) => { };

	var endPoint = Constants.GetAllEndPoint + "/" + Constants.SystemPropertiesTableName;

	General.GetFromEndPoint(endPoint, null, null, GetSystemPropertiesSuccess, GetSystemPropertiesFailure);
};
